var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sub",class:[_vm.size]},[(_vm.$slots.default)?_c('div',{staticClass:"visual"},[_vm._t("default")],2):_vm._e(),_c('Caption',{attrs:{"darkText":true,"head":_vm.head,"text":_vm.text,"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }